import { createRouter, createWebHistory } from "vue-router";

const routes = [
   {
      path: "/auth",
      name: "auth",
      component: () => import("../views/Auth/AuthView.vue"),
      meta: {
         title: "Inicia sesión |  NIDO",
      },
   },
   {
      path: "/renewSubscription",
      name: "renewSubscription",
      component: () => import("../views/Auth/RenewSubscriptionView.vue"),
      meta: {
         title: "Renueva tu suscripción |  NIDO",
      },
   },
   {
      path: "/payment/:paymentRequestId",
      name: "payment",
      component: () => import("../views/Payments/PaymentView.vue"),
      meta: {
         title: "Realiza tu pago |  NIDO",
      },
   },
   {
      path: "/paymentResponse/:paymentRequestId",
      name: "paymentResponse",
      component: () => import("../views/Payments/PaymentResponseView.vue"),
      meta: {
         title: "Realiza tu pago |  NIDO",
      },
   },
   {
      path: "/",
      name: "home",
      meta: {
         title: "Inicio |  NIDO",
      },
      component: () => import("../views/HomeView.vue"),
      redirect: "/dashboard",
      children: [
         {
            path: "/dashboard",
            name: "dashboard",
            component: () => import("../views/Companies/CompanyView.vue"),
            meta: {
               title: "Inicio |  NIDO",
            },
         },
         {
            path: "/profile",
            name: "profile",
            meta: {
               title: "Perfil |  NIDO",
            },
            component: () => import("../views/ProfileView.vue"),
         },
         {
            path: "/users",
            name: "users",
            component: () => import("../views/Users/UsersView.vue"),
            meta: {
               title: "Usuarios |  NIDO",
            },
         },
         {
            path: "/employees",
            name: "employees",
            component: () => import("../views/Users/EmployeesView.vue"),
            meta: {
               title: "Empleados |  NIDO",
            },
         },
         {
            path: "/roles",
            name: "roles",
            component: () => import("../views/Users/RolesView.vue"),
            meta: {
               title: "Roles |  NIDO",
            },
         },
         {
            path: "/branches",
            name: "branches",
            component: () => import("../views/Companies/BranchesView.vue"),
            meta: {
               title: "Sedes |  NIDO",
            },
         },
         {
            path: "/clients",
            name: "clients",
            component: () => import("../views/Clients/ClientsView.vue"),
            meta: {
               title: "Clientes |  NIDO",
            },
         },
         {
            path: "/services",
            name: "services",
            component: () => import("../views/Companies/ServicesView.vue"),
            meta: {
               title: "Servicios |  NIDO",
            },
         },
         {
            path: "/service/:serviceId",
            name: "service",
            component: () => import("../views/Companies/ServiceView.vue"),
            meta: {
               title: "Servicio |  NIDO",
            },
         },
         {
            path: "/createAppointment",
            name: "createAppointment",
            component: () =>
               import("../views/Checkins/CreateAppointmentView.vue"),
            meta: {
               title: "Ingresos |  NIDO",
            },
         },
         {
            path: "/checkins",
            name: "checkins",
            component: () => import("../views/Checkins/CheckinsView.vue"),
            meta: {
               title: "Ingresos |  NIDO",
            },
         },
         {
            path: "/appointments",
            name: "appointments",
            component: () => import("../views/Checkins/AppointmentsView.vue"),
            meta: {
               title: "Citas |  NIDO",
            },
         },
         {
            path: "/reports",
            name: "reports",
            component: () => import("../views/Companies/ReportsView.vue"),
            meta: {
               title: "Ingresos |  NIDO",
            },
         },
         {
            path: "/inputs",
            name: "inputs",
            component: () => import("../views/Companies/InputsView.vue"),
            meta: {
               title: "Insumos |  NIDO",
            },
         },
         {
            path: "/consume_deductions",
            name: "consume_deductions",
            component: () =>
               import("../views/Companies/ConsumeDeductionsView.vue"),
            meta: {
               title: "Consumos y deducciones |  NIDO",
            },
         },
         {
            path: "/expenses",
            name: "expenses",
            component: () => import("../views/Companies/ExpensesView.vue"),
            meta: {
               title: "Egresos |  NIDO",
            },
         },
         {
            path: "/employeesPayments",
            name: "employeesPayments",
            component: () => import("../views/Companies/EmployeesPayments.vue"),
            meta: {
               title: "Pagos a empleados |  NIDO",
            },
         },
         {
            path: "/inventories",
            name: "inventories",
            component: () => import("../views/Companies/InventoriesView.vue"),
            meta: {
               title: "Inventarios |  NIDO",
            },
         },
         {
            path: "/inventories/suppliers",
            name: "inventorySuppliers",
            component: () =>
               import("../views/Companies/InventorySuppliersView.vue"),
            meta: {
               title: "Proveedores | Inventarios | NIDO",
            },
         },
         {
            path: "/inventories/products",
            name: "inventoryProducts",
            component: () =>
               import("../views/Companies/InventoryProductsView.vue"),
            meta: {
               title: "Productos | Inventarios | NIDO",
            },
         },
         {
            path: "/inventories/formulations",
            name: "inventoryFormulations",
            component: () =>
               import("../views/Companies/InventoryFormulationsView.vue"),
            meta: {
               title: "Formulaciones | Inventarios | NIDO",
            },
         },
         {
            path: "/inventories/reports",
            name: "inventoryReports",
            component: () =>
               import("../views/Companies/InventoryReportsView.vue"),
            meta: {
               title: "Reportes | Inventarios | NIDO",
            },
         },
      ],
   },
   {
      path: "/resetPass",
      name: "resetPass",
      component: () => import("../views/Auth/ResetPassView.vue"),
      meta: {
         title: "Restablece tu contraseña |  NIDO",
      },
   },
   {
      path: "/forgotPassword",
      name: "forgotPassword",
      component: () => import("../views/Auth/ForgotPasswordView.vue"),
      meta: {
         title: "Recupera tu contraseña |  NIDO",
      },
   },
   {
      path: "/OTPResetPass",
      name: "OTPResetPass",
      component: () => import("../views/Auth/OTPResetPassView.vue"),
      meta: {
         title: "Recupera tu contraseña |  NIDO",
      },
   },
];

const router = createRouter({
   history: createWebHistory(process.env.BASE_URL),
   routes,
});

router.beforeEach((to) => {
   document.title = to.meta?.title ?? " NIDO";
});

export default router;
